'use es6';

export const sumTotalNestedFileCountAndSelectedFiles = (totalNestedFileCount, currentBulkSelection) => {
  return totalNestedFileCount + currentBulkSelection.size;
};